





















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class CdrDetailContentJifentiao extends Vue {
  @Prop()
  private content: any;
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }
  private formatTooltio(val) {
    return val + "分";
  }
}
